import * as React from 'react';

export const IconSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      d="M12.481 0a.66.66 0 0 0 .16 0 2.21 2.21 0 0 1 1.58 1c.165.272.258.582.27.9a2 2 0 0 1-.66 1.6l-1.86 1.82-1.19 1.11h-.05a.37.37 0 0 1-.51 0l-.58-.5L7.521 4l-.4-.42a2 2 0 0 1-.62-1.06 1.93 1.93 0 0 1 .33-1.59A2.19 2.19 0 0 1 8.221 0h.7c.325.032.639.135.92.3.167.097.322.215.46.35.047.05.097.097.15.14l.2-.19a2.26 2.26 0 0 1 1.15-.6h.68zm-7.49 1.6v1.46a3.26 3.26 0 0 0-2.62 1 3.15 3.15 0 0 0-.88 1.87 3.28 3.28 0 0 0 2.3 3.53 3.22 3.22 0 0 0 2.36-.17 3.27 3.27 0 0 0 1.64-1.7l1.38.5a4.75 4.75 0 0 1-.66 1.16l4.52 3.8-1.55 1.55-3.81-4.5a4.73 4.73 0 0 1-3.82.9 4.61 4.61 0 0 1-2.62-1.48 4.74 4.74 0 0 1 3.76-7.92z"
      fill="currentColor"
      fillRule="evenodd"
      opacity=".9"
    />
  </svg>
);
